import React from 'react';
import DocumentViewModal from '../../../components/Modals/documentView/DocumentViewModal';
import SaleHeaderView from '../../../components/Sales/viewTables/SaleHeaderView';
import RecordViewTable from '../../../components/Tables/recordReusable/RecordViewTable';
import { saleColumnsMap } from '../../../features/document/columns/sales';
import { useSale } from '../../../hooks/sale/useSale';
import PaymentConditionViewSection from '../../../components/Modals/documentView/PaymentConditionViewSection';
import DocumentTotalsSummary from '../../../components/Modals/documentView/DocumentTotalsSummary';
import { DOCUMENT_TYPE_CODES } from '../../../constants/documentTypeCodes';

const SaleHeaderViewWrapper: React.FC<{ data: any }> = ({ data }) => {
  return <SaleHeaderView sale={data} />;
};

interface SaleViewModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SaleViewModal: React.FC<SaleViewModalProps> = ({ isOpen, onClose }) => {
  const { form } = useSale();

  const documentTypeCode = form.documentType?.code;

  // 🔥 Resolver columnas según código MH
  const getColumnsByDocumentType = () => {
    switch (documentTypeCode) {
      case DOCUMENT_TYPE_CODES.TAX_CREDIT:
        return saleColumnsMap.TAX_CREDIT;

      case DOCUMENT_TYPE_CODES.CREDIT_NOTE:
        return saleColumnsMap.CREDIT_NOTE;

      case DOCUMENT_TYPE_CODES.EXPORT_INVOICE:
        return saleColumnsMap.EXPORT_INVOICE;

      case DOCUMENT_TYPE_CODES.INVOICE:
        return saleColumnsMap.CONSUMER_INVOICE;

      default:
        return saleColumnsMap.CONSUMER_INVOICE;
    }
  };

  const columns = getColumnsByDocumentType();

  return (
    <DocumentViewModal
      isOpen={isOpen}
      onClose={onClose}
      document={form}
      type="sale"
      title="Detalle de la Venta"
      columns={columns}
      HeaderView={SaleHeaderViewWrapper}
      ProductsTable={(props) => (
        <RecordViewTable
          {...props}
          totals={form.totals}
          renderFooterContent={(totals) => (
            <DocumentTotalsSummary totals={totals} />
          )}
        />
      )}
      PaymentConditionSection={() => (
        <PaymentConditionViewSection type="sale" />
      )}
    />
  );
};

export default SaleViewModal;
